import React, { useEffect, useState } from "react";
import Quick_links from "../utility/Quick_links";
import services from "../services/services";
import { useForm } from "react-hook-form";
import $ from 'jquery';
import { useNavigate } from "react-router-dom";

const WageSurveyData = () => {
    const navigate = useNavigate();
    const [stateList, setStateList] = useState([]);
    const [countyList, setCountyList] = useState([]);
    
    // --- New States for Custom Search ---
    const [jobSuggestions, setJobSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [jobInput, setJobInput] = useState("");
    const [socCode, setSocCode] = useState('');
    const [jobCodeTitle, setJobCode] = useState('');

    const companyIdChkLogin = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");
    const emailLogin = sessionStorage.getItem("logEmail") || localStorage.getItem("logEmail");
    const userIdLogin = sessionStorage.getItem("logUserId") || localStorage.getItem("logUserId");

    const { handleSubmit, formState: { errors } } = useForm({
        criteriaMode: "all", mode: "onBlur"
    });

    useEffect(() => {
        if (!companyIdChkLogin || companyIdChkLogin === "null") {
            navigate('/Home');
            return;
        }

        getStatesWage();

        // Default to OH
        setTimeout(() => {
            $("#stateId").val('OH');
            getCountyByState('OH');
        }, 1000);

        // Numeric validation via jQuery
        $(".allow_numeric3, .allow_numericd").keyup(function() {
            const regex = this.classList.contains('allow_numeric3') ? /^\d{0,3}(\.\d{0,2})?$/ : /^\d{0,7}(\.\d{0,2})?$/;
            if (!regex.test(this.value)) {
                this.value = this.value.substring(0, this.value.length - 1);
            }
        });

        // Hide error labels on load
        $('.error-label').hide();
        $("#successMessage").hide();

        // Close dropdown when clicking outside
        const closeMenu = () => setShowSuggestions(false);
        window.addEventListener("click", closeMenu);
        return () => window.removeEventListener("click", closeMenu);
    }, []);

    // --- API & Search Logic ---
    const handleJobSearch = (e) => {
        const value = e.target.value;
        setJobInput(value);
        if (value.length > 1) {
            fetch('https://wagesurvey.hometownopportunity.com/api/jobSugList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ title: value }),
            })
            .then(res => res.json())
            .then(data => {
                setJobSuggestions(data || []);
                setShowSuggestions(true);
            });
        } else {
            setJobSuggestions([]);
        }
    };

    const selectJob = (item) => {
        setJobCode(item.title);
        setSocCode(item.socCode);
        setJobInput(item.title);
        setShowSuggestions(false);
    };

    const getStatesWage = () => {
        services.getStatesFromWage().then((res) => setStateList(res.data || []));
    };

    const getCountyByState = (stateId) => {
        services.getCountyByStateFromWage({
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ "stateCode": stateId })
        }).then((res) => {
            if (res) {
                let temp = res;
                if (stateId === 'OH') {
                    temp = temp.filter(e => ['Auglaize County', 'Darke County', 'Shelby County', 'Mercer County'].includes(e.countyName));
                }
                setCountyList(temp);
            }
        });
    };

    const submitValue = () => {
        // Validation Logic
        if ($('#stateId').val() === '') { $('#statecheck').show(); return false; }
        if ($('#countyId').val() === '') { $('#countycheck').show(); return false; }
        if ($('#cityId').val() === '') { $('#citycheck').show(); return false; }
        if (!socCode) { $("#soc_code_check").show(); return false; }

        const requestObject = {
            "sourceDomain": "hometownopportunity.com",
            "emailAddress": emailLogin,
            "uid": userIdLogin,
            "companyIdRef": companyIdChkLogin,
            "wageArr": [{
                "state": $("#stateId").val(),
                "city": $("#cityId").val(),
                "county": $("#countyId").val(),
                "job_title": jobCodeTitle,
                "job_code": jobCodeTitle,
                "socCode": socCode,
                "junior_h": $("#junior_h1").val(),
                "junior_y": $("#junior_y1").val(),
                "midlevel_h": $("#midlevel_h1").val(),
                "midlevel_y": $("#midlevel_y1").val(),
                "manager_h": $("#manager_h1").val(),
                "manager_y": $("#manager_y1").val(),
                "excutive_h": $("#excutive_h1").val(),
                "excutive_y": $("#excutive_y1").val(),
            }]
        };

        const accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
        services.postWageSurvey({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + accessTokenIn
            },
            body: JSON.stringify(requestObject)
        }).then((res) => {
            $("#successMessage").show();
            setTimeout(() => { navigate('/companyJobs'); }, 2000);
        });
    };

    return (
        <>
            <main className="empr-directory-main">
                <div className="main-bgpatten"></div>
                <section className="headtitle-wrap">
                    <div className="container">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item headtitle "><a href="/companyJobs">Company Dashboard</a></li>
                                <li className="breadcrumb-item headtitle  active">Wage Survey</li>
                            </ol>
                        </nav>
                    </div>
                </section>

                <section className="py-5">
                    <div className="container">
                        <div className="white-bg p-5">
                            <div className="row">
                                <Quick_links />
                                <div className="col-lg-8 mb-4">
                                    <form onSubmit={handleSubmit(submitValue)}>
                                        <div className="row resume-wrap">
                                            {/* State Select */}
                                            <div className="col-lg-12 mb-4">
                                                <label className="form-label">State<span className="red-text">*</span></label>
                                                <select className="form-select" id="stateId" onChange={(e) => getCountyByState(e.target.value)}>
                                                    <option value="">List of States</option>
                                                    {stateList.map((data, idx) => (
                                                        <option key={idx} value={data.stateCode}>{data.stateName}</option>
                                                    ))}
                                                </select>
                                                <div id="statecheck" className="error-label text-danger">State is required</div>
                                            </div>

                                            {/* County Select */}
                                            <div className="col-lg-12 mb-4">
                                                <label className="form-label">County<span className="red-text">*</span></label>
                                                <select className="form-select" id="countyId">
                                                    <option value="">List of Counties</option>
                                                    {countyList.map((data, idx) => (
                                                        <option key={idx} value={data.countyName}>{data.countyName}</option>
                                                    ))}
                                                </select>
                                                <div id="countycheck" className="error-label text-danger">County is required</div>
                                            </div>

                                            {/* City Input */}
                                            <div className="col-lg-12 mb-4">
                                                <label className="form-label">City<span className="red-text">*</span></label>
                                                <input type="text" className="form-control" id="cityId" />
                                                <div id="citycheck" className="error-label text-danger">City is required</div>
                                            </div>

                                            {/* CUSTOM JOB SEARCH (Replacing AsyncSelect) */}
                                            <div className="col-lg-12 mb-4 position-relative">
                                                <label className="form-label">Standardized job code<span className="red-text">*</span></label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={jobInput} 
                                                    onChange={handleJobSearch} 
                                                    autoComplete="off"
                                                    placeholder="Type to search..."
                                                />
                                                {showSuggestions && jobSuggestions.length > 0 && (
                                                    <ul className="list-group position-absolute w-100 shadow" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                                                        {jobSuggestions.map((item, idx) => (
                                                            <li 
                                                                key={idx} 
                                                                className="list-group-item list-group-item-action" 
                                                                onClick={(e) => { e.stopPropagation(); selectJob(item); }}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {item.title} ({item.socCode})
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                                <div id="soc_code_check" className="error-label text-danger">Standardized job code is required.</div>
                                            </div>

                                            {/* SOC Info Display */}
                                            <div className="col-lg-12 mb-4">
                                                <p><strong>Soc Code:</strong> {socCode}</p>
                                                <p><strong>Job Title:</strong> {jobCodeTitle}</p>
                                            </div>

                                            {/* Wage Levels (Level 1 Example - Repeat for 2, 3, 4) */}
                                            {[
                                                { id: 'junior', label: 'Level 1', sub: 'Junior' },
                                                { id: 'midlevel', label: 'Level 2', sub: 'Mid Level' },
                                                { id: 'manager', label: 'Level 3', sub: 'Managerial' },
                                                { id: 'excutive', label: 'Level 4', sub: 'Executive' }
                                            ].map((lvl) => (
                                                <div className="wage mb-3" key={lvl.id}>
                                                    <div className="wage-item">
                                                        <div className="d-grid">
                                                            <b>{lvl.label} <span className="red-text">*</span></b>
                                                            <small>{lvl.sub}</small>
                                                        </div>
                                                    </div>
                                                    <div className="wage-item">
                                                        <label>Hourly</label>
                                                        <input type="text" className="form-control allow_numeric3" id={`${lvl.id}_h1`} />
                                                    </div>
                                                    <div className="wage-item">
                                                        <label>Yearly</label>
                                                        <input type="text" className="form-control allow_numericd" id={`${lvl.id}_y1`} />
                                                    </div>
                                                </div>
                                            ))}

                                            <div className="col-lg-12 mb-4">
                                                <button type="submit" className="reg-button">Submit Survey</button>
                                            </div>
                                            
                                            <div id="successMessage" className="alert alert-success">
                                                Wage survey data has been inserted successfully
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};

export default WageSurveyData;